const ID_RE = /^[a-z0-9]{8}$/;

export function buildCertPath({ slug, id }) {
  return slug ? `/c/${slug}-${id}` : `/c/${id}`;
}

export function parseCertPath(pathname) {
  if (!pathname.startsWith('/c/')) return null;
  const tail = pathname.slice(3);
  const lastDash = tail.lastIndexOf('-');
  if (lastDash === -1) {
    return ID_RE.test(tail) ? { slug: '', id: tail } : null;
  }
  const id = tail.slice(lastDash + 1);
  if (!ID_RE.test(id)) {
    return ID_RE.test(tail) ? { slug: '', id: tail } : null;
  }
  return { slug: tail.slice(0, lastDash), id };
}

export function certShareUrl(origin, { slug, id }) {
  return origin + buildCertPath({ slug, id });
}
